/*
Item: DataContainer Component for  Drag'n'Drop in Statistics.jsx, Source for Cards
Name: DataContainer
Format: Code/Frontend component
*/

import React, { Component } from 'react';
// import update from 'immutability-helper'
import { DropTarget } from 'react-dnd';
import SourceCard from './SourceCard';

class DataContainer extends Component {
  constructor(props) {
    super(props);
    // this.state = { cards: props.list };
    this.moveCard = this.props.moveCard;
    this.clearInput = this.props.clearInput;
    this.showSearchOverlay = this.props.showSearchOverlay;
  }

  searchField() {
    const { overlayHasFilter, overlayId } = this.props;
    let color = { color: '#eee' };
    if (overlayHasFilter[overlayId]) color = { color: '#757575' };
    return (
      <span style={{ color, fontSize: '9px' }}>
        <i
          id="clearFilter"
          name="arrowDownOverlay"
          style={color}
          className="pi pi-md-filter-list"
          onClick={(e) => this.clearInput(e, overlayId)}
        />
        <i
          id="arrowDownOverlay"
          name="arrowDownOverlay"
          className="pi pi-md-arrow-drop-down"
          onClick={(e) => this.showSearchOverlay(e, overlayId)}
        />
      </span>
    );
  }

  render() {
    const cards = this.props.list;
    const {
      canDrop, isOver, connectDropTarget, header,
    } = this.props;
    const isActive = canDrop && isOver;

    const backgroundColor = isActive ? 'lightgreen' : '#FFF';
    return connectDropTarget(
      <div className="card" style={{ backgroundColor }}>
        <span>
          <span style={{ color: '#999', fontSize: '12px' }}>
            {header}
          </span>
          {this.showSearchOverlay ? this.searchField() : undefined}
        </span>
        {cards.map((card, i) => {
          let ret;
          const { id } = this.props;
          if (card) {
            ret = (
              <SourceCard
                key={card.id}
                index={i}
                listId={id}
                card={card}
              />
            );
          }
          return ret;
        })}
      </div>,
    );
  }
}

const cardTarget = {
  drop(props, monitor, component) {
    // const { id } = props;
    // const sourceObj = monitor.getItem();
    /*
    if ( id !== sourceObj.listId ) component.pushCard(sourceObj.card);
    return {
      listId: id
    };
    */
  },
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(DataContainer);

// export default TestContainer
